module.exports = __webpack_public_path__ + "static/media/pool-img2.d1964c54.svg";